<template>
  <div>
    <b-row class="m-0 text-center instance min-height" id="min-height">
      <b-col class="p-0 bg_d">
        <div class="img-cover">
        </div>
        <img class="d-block img-fluid w-100" width="100%" :src="itemData.sourceUrl" alt="" />
        <div class="innerbox">
          <div class="instance-txt" @click="todetial" v-if="itemData.postTitle">
            <i class="vedio_icon" v-if="itemData.type == '视频'"></i>
             {{itemData.postTitle}}
            <!-- 2 New Imported Cases Reported In Shanghai -->
          </div>
          <span class="text-uppercase metro-btn" v-if="itemData.category" v-for="(item,index) in categoryList"
            :key="index"
           @click="goToNews(item)">
            {{item}}
          </span>
          <!-- <span class="metro-btn" v-if="itemData.category">
            {{itemData.category}}
          </span> -->
        </div>
        <div class="cover"></div>
      </b-col>
    </b-row>
  </div>
</template>

<script>
export default {
  name: "Instance",
  // props: {
  //   instance: {
  //     type: Array,
  //     default() {
  //       return [];

  //     }
  //   }
  // },

  props: ["itemData"],
  data() {
    return {
      categoryList: [],
      playerHeight: 0,
    };
  },
  computed: {
    // setImgFn(){
    //   return function(url){
    //     let index =  url.lastIndexOf('.');
    //     let tempUrl = url.slice(0,index)+'_index'+ url.slice(index);
    //     return tempUrl;
    //   }
    // }
  },
  methods: {
    //  首页图片改成16/9的比例
    handelWidth() {
      var container = document.getElementsByClassName("min-height");
      // var innerbox = document.getElementsByClassName("innerbox");

      this.playerHeight = container[0].clientWidth / (16 / 9) + "px";
      for (var i = 0; i < container.length; i++) {
        container[i].style.height = this.playerHeight;
        // innerbox[i].style.top = "50%";
      }
    },

    gitCategoryFn() {
      if (this.itemData.category) {
        this.categoryList = this.itemData.category.split(",");
      }
      // console.log(this.categoryList,'this.categoryList')
    },
    goToNews(item) {
      this.$router
        .push({
          path: "/News",
          query: {
            cT: item,
          },
        })
        .catch(err => {
          err;
        });
    },
    todetial() {
      // console.log(this.itemData.postId)
      this.$router.push({
        path: "/detail",
        query: {
          postId: this.itemData.postId,
        },
      });
    },
  },
  mounted() {
    this.gitCategoryFn();
    // console.log(this.instance)
    this.handelWidth();
  },
};
</script>

<style lang="less">
// instance
.instance {
  font-family: FranklinGothic-Demi;
  color: #ffffffff;
  position: relative;
  .bg_d {
    background: url("../../../assets/imgs/home/bg_img.jpg");
    background-size: contain;
  }
  // cursor: pointer;
}
.innerbox {
  width: calc(100% - 0.4rem);
  // margin: 0 0.2rem;
  font-size: 0.55rem;
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  .instance-txt {
    cursor: pointer;
    text-overflow: -o-ellipsis-lastline;
    overflow: hidden;
    text-overflow: ellipsis;
    display: -webkit-box;
    -webkit-line-clamp: 3;
    -webkit-box-orient: vertical;
    line-clamp: 3;
    padding: 0 35px;
    letter-spacing: 1.5px;
    line-height: 44px;
    white-space: pre-line;
  }
  .vedio_icon {
    display: inline-block;
    height: 0.6rem;
    width: 0.6rem;
    background: url("../../../assets/imgs/home/vedio_icon.png") no-repeat;
    background-size: 100% 100%;
    cursor: pointer;
    position: relative;
    top: 0.1rem;
  }
  .metro-btn {
    position: relative;
    // top: 0.5rem;
    border: 1.3px solid #ffffff;
    cursor: pointer;
    font-size: 9px;
    margin-right: 6px;
    letter-spacing: 4px;
    padding: 4px 3px 2px 7px;
    font-family: Calibri Bold;
    // font-weight:bolder;
  }
  .metro-btn:hover {
    background: rgba(0, 0, 0, 0.8);
    border: none;
    border-radius: 5px;
  }
}

@media screen and (min-width: 768px) {
  .instance {
    font-family: FranklinGothic-Demi;
    position: relative;
    .innerbox {
      width: calc(100% - 0.4rem);
      // margin: 0 0.2rem;
      font-size: 36px !important;
    }
    color: #ffffffff;
    .bg_d {
      position: relative;
      background: url("../../../assets/imgs/home/bg_img.jpg");
      background-size: contain;
    }
    // cursor: pointer;
  }
  .min-height {
    // height: 640px;
    overflow: hidden;
    img {
      min-height: 100%;
    }
  }
}
@media screen and (max-width: 768px) {
  .min-height {
    height: 235px;
    overflow: hidden;
    img {
      min-height: 235px;
    }
  }
  .innerbox {
    width: calc(100% - 0.4rem);
    // margin: 0 0.2rem;
    font-size: 20px;
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    .instance-txt {
      width: calc(100% - 0.4rem);
      cursor: pointer;
      text-overflow: -o-ellipsis-lastline;
      overflow: hidden;
      text-overflow: ellipsis;
      display: -webkit-box;
      -webkit-line-clamp: 3;
      -webkit-box-orient: vertical;
      line-clamp: 3;
      line-height: 24px;
      padding: 0 15px;
      white-space: pre-line;
    }
    .vedio_icon {
      display: inline-block;
      height: 20px;
      width: 20px;
      background: url("../../../assets/imgs/home/vedio_icon.png") no-repeat;
      background-size: 100% 100%;
      cursor: pointer;
      position: relative;
      top: 0.1rem;
    }
    .metro-btn {
      position: relative;
      // top: 0.2rem;
      border: 1.3px solid #ffffff;
      cursor: pointer;
      font-size: 9px;
      letter-spacing: 4px;
      padding: 4px 3px 2px 7px;
    }
    .metro-btn:hover {
      background: rgba(0, 0, 0, 0.8);
      border: none;
      border-radius: 5px;
    }
  }
}
</style>